export function humanizeSlug(slug?: string): string {
  if (!slug) return ''
  return slug.replace(/-/g, ' ')
}
